// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__34nlE","label":"CategoryService_label__2agTk","location":"CategoryService_location__2S-cP"};